<app-shared-site-loader *ngIf="showLoading | async"></app-shared-site-loader>
<app-site-loader></app-site-loader>
<router-outlet></router-outlet>
